export function handleChangeAmount(event, validateInput) {
    event.preventDefault();
    const target = event.target;
    let name = target.name;
    let val = target.value === "" ? "" : target.value;
  
    if (val !== "") {
      val = val.replace(/[^-\d.]/g, "");
      val = val.replace(/-{2,}/g, "-");
      val = val.replace(/-(?=[^\d.])/g, "");
      val = val.replace(/\.(?=.*\.)/g, "");
    }
  
    target.value = val;
    this.setState({ [name]: val });
    return ({[name]: val});
  }